import DateTime from '../dateTime/DateTime';
import InvalidOperationError from './InvalidOperationError';
import StringUtils from '../text/StringUtils';
export default class DefaultComparer {
    static compare(obj1, obj2) {
        if (obj1 === undefined && obj2 === undefined) {
            return 0;
        }
        else if (obj1 === undefined && obj2 !== undefined) {
            return -1;
        }
        else if (obj1 !== undefined && obj2 === undefined) {
            return 1;
        }
        else if (obj1 === null && obj2 === null) {
            return 0;
        }
        else if (obj1 === null && obj2 !== null) {
            return -1;
        }
        else if (obj1 !== null && obj2 === null) {
            return 1;
        }
        else if (typeof obj1.compare === 'function') {
            return obj1.compare(obj2);
        }
        else if (typeof obj2.compare === 'function') {
            return -obj2.compare(obj1);
        }
        else if (StringUtils.isString(obj1) && StringUtils.isString(obj2)) {
            return StringUtils.compare(obj1, obj2);
        }
        else if (DateTime.isDate(obj1) && DateTime.isDate(obj2)) {
            return DateTime.compare(obj1, obj2);
        }
        else if (obj1 < obj2) {
            return -1;
        }
        else if (obj1 > obj2) {
            return 1;
        }
        else if (obj1 === obj2) {
            return 0;
        }
        throw new InvalidOperationError('Type is not comparable or inconsistent.');
    }
    ;
}
//# sourceMappingURL=DefaultComparer.js.map